import axios from 'axios';
import { config } from '../../../config/env';

export interface CreditsResumeResponse {
  hasSubscription: boolean;
  hasBonus: boolean;
  hasPurchase: boolean;
}

const url = `${config.jusfyBackend.apiUrl}/credits/resume`;

export async function getCreditsResume(
  signal?: AbortSignal,
): Promise<CreditsResumeResponse> {
  const { data } = await axios.get<CreditsResumeResponse>(url, { signal });
  return data;
}
